import { useState } from 'react'
import { useApolloClient } from '@apollo/client'
import { PUBLIC_OPEN_ED_API } from '@mth/envs'
import { getOpenEdToken } from '@mth/graphql/queries/intent-to-reenroll'

interface UseOpenedMagicLinkResult {
  loading: boolean
  displayOpenedTab: () => Promise<void>
}

interface UseOpenedMagicLinkProps {
  userId: number
  callback?: () => Promise<void>
}

export const UseOpenedMagicLink = ({ userId, callback }: UseOpenedMagicLinkProps): UseOpenedMagicLinkResult => {
  const [loading, setLoading] = useState(false)
  const client = useApolloClient()

  const displayOpenedTab = async () => {
    setLoading(true)
    try {
      const newWindow = window.open()
      if (!newWindow) {
        console.error('Popup window could not be opened, it might have been blocked.')
        return
      }
      const { data } = await client.query({
        query: getOpenEdToken,
        variables: {
          userId: Number(userId),
        },
        fetchPolicy: 'network-only',
      })
      const redirect = encodeURIComponent('/parents/migrate')
      let url = `${PUBLIC_OPEN_ED_API}auth/login-token?`

      url += `token=${encodeURIComponent(data.getOpenEdToken)}&redirect=${redirect}`
      newWindow.location.href = url
      if (callback) await callback()
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  return { loading, displayOpenedTab }
}
